/* istanbul ignore file */
export { default } from './VehicleDescription';
